import * as React from "react";

import { cn } from "./utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Base styles with 44px min-height
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex min-h-[44px] w-full min-w-0 rounded-xl border px-3 py-2 text-base bg-input-background outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // Smooth transitions
        "transition-all duration-150",
        // Focus states with smooth ring animation
        "focus-visible:focus-ring focus-visible:border-coral focus-visible:ring-coral/20",
        // Valid states (for forms with validation)
        "valid:border-sage valid:ring-sage/10",
        // Error states with enhanced feedback
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive aria-invalid:ring-2",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
